import { Button, Modal, Text } from "@marketplace/ui";
import { useAtomValue } from "jotai";
import { useResetAtom } from "jotai/utils";
import { useTranslation } from "react-i18next";

import { deleteSellerModalAtom } from "../../atoms";
import { useDeleteSellerMutation } from "../../hooks/mutations/use-delete-seller-mutation";

export const DeleteSellerModal = () => {
  const { t } = useTranslation("users");
  const { visible, data } = useAtomValue(deleteSellerModalAtom);
  const resetDeleteSellerModal = useResetAtom(deleteSellerModalAtom);
  const { mutate: deleteSeller, isPending } = useDeleteSellerMutation();

  const handleDelete = () => {
    if (data?.id) {
      deleteSeller(
        { sellerId: data.id },
        {
          onSuccess: () => {
            resetDeleteSellerModal();
          }
        }
      );
    }
  };

  return (
    <Modal
      opened={visible}
      onClose={resetDeleteSellerModal}
      title={
        <Text type="heading">{t("sellerListPage.deleteModal.title")}</Text>
      }
      size={400}
      withCloseButton={false}
      classNames={{
        header: "!pt-6 !pb-0 !min-h-fit",
        body: "!p-6"
      }}
    >
      <Text type="paragraph" className="text-center mb-6">
        {t("sellerListPage.deleteModal.description")}
      </Text>

      <div className="flex gap-x-[14px]">
        <Button fullWidth variant="secondary" onClick={resetDeleteSellerModal}>
          {t("sellerListPage.deleteModal.button.cancel")}
        </Button>
        <Button
          fullWidth
          variant="primary"
          onClick={handleDelete}
          loading={isPending}
        >
          {t("sellerListPage.deleteModal.button.delete")}
        </Button>
      </div>
    </Modal>
  );
};
